import { ENVS } from './environments.constants';

export const environment = {
  production: true,
  apiUrl: ``,
  name: ENVS.TEST,
  cidiURl: 'https://cidi.cba.gov.ar',
  vediURl: 'https://vedi.cordoba.gob.ar/VeDiLandingPage',
  consultaPadronesQR: 'https://calidadalimentariadigital.cordoba.gob.ar/padrones/consulta-qr',
  filesUrl: 'https://prod-alimentos-s3-public.s3.amazonaws.com/'
};
